import { render, staticRenderFns } from "./ObstacleModal.vue?vue&type=template&id=fd10e50e&scoped=true"
import script from "./ObstacleModal.vue?vue&type=script&lang=ts"
export * from "./ObstacleModal.vue?vue&type=script&lang=ts"
import style0 from "./ObstacleModal.vue?vue&type=style&index=0&id=fd10e50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd10e50e",
  null
  
)

export default component.exports